import React from 'react'
import AlertModal from './AlertModal';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import { useTranslation } from 'react-i18next';

const ShowDownloadRevitErrorModal = (props) => {

  const { t } = useTranslation();
  const modalTitle = t( 'modal.wizard_info.default_title' );
  const ht = useCustomHtmlTranslation();

  return (
    <AlertModal
      modalTitle={ modalTitle }
    >
    { ht('product_solution_download_revit_error_info') }
    </AlertModal>
  )
}

export default ShowDownloadRevitErrorModal



// WEBPACK FOOTER //
// ./src/components/Modals/ShowDownloadRevitErrorModal.js